// src/config/gameProfiles/profileRegistry.ts
// -------------------------------------------------------
// Auto-detection + registry for all game profiles.
// To add a new game type: import it, push it to ALL_PROFILES.
// -------------------------------------------------------

import type { GameProfile } from './GameProfile';
import { kcvProfile } from './kcvProfile';
import { designThinkingProfile } from './designThinkingProfile';

/**
 * All registered profiles.
 * Order matters: first match wins in detectProfile().
 * Put more specific profiles before generic ones.
 */
const ALL_PROFILES: GameProfile[] = [
  designThinkingProfile,  // check first (more specific keywords)
  kcvProfile,             // fallback / generic exam
];

/**
 * Auto-detect the correct profile from the system prompt content.
 * Scans for keywords defined in each profile's `detectKeywords`.
 */
export function detectProfile(systemPrompt: string): GameProfile {
  const lower = (systemPrompt || '').toLowerCase();

  for (const profile of ALL_PROFILES) {
    if (profile.detectKeywords.some(kw => lower.includes(kw))) {
      return profile;
    }
  }

  // Fallback: KCV (preserves existing behavior)
  return kcvProfile;
}

/**
 * Look up a profile by its id.
 */
export function getProfileById(id: string): GameProfile | undefined {
  return ALL_PROFILES.find(p => p.id === id);
}

/**
 * Get all registered profiles (for UI listing, etc.)
 */
export function getAllProfiles(): readonly GameProfile[] {
  return ALL_PROFILES;
}
